module.exports = "images/high_performance_desktops.webp";